module.exports = __webpack_public_path__ + "img/banner1.b9b01877.jpg";